import React, {useEffect} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { useState } from 'react'
import MeChildHeader from '../../../components/me-child-header'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import MeLoading from '../../../components/loading'
import { useIntl } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'
import { useStore } from 'react-redux'
import { useQuery } from '../../../../../hooks/common'
import { action_fetch_orders_notification } from '../../../../../../store/actions/pages/customer'
import NotificationList from '../components/notification-list'


const NotificationOrders = props => {
    useStyles(classes);
    const Intl = useIntl()

    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(true)
    const [dataList, setDataList] = useState([])
    const pageCustomer = useSelector(state => state.pageCustomer)
    const { notifications, notificationLoading, notificationFinished } = pageCustomer || {}
    const showType = 'orders'


    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
            await NotificationOrders.fetchData(store, params, query)
		}
    }, [])

    useEffect(() => {
        if(notifications?.[showType]){
            setLoading(false)
            if(notifications?.[showType]?.length >0){
                setDataList(notifications[showType])
            }
        } else {
            setTimeout(() => {
                setLoading(false)
            }, 3000)
        }
    },[notifications])



    return <div className={classes.NotificationPage}>
        <MeChildHeader name={Intl.formatMessage({id: 'orders'})}/>

        <NotificationList
            notifications={dataList}
            loading={notificationLoading?.[showType]}
            finished={notificationFinished?.[showType]}
            hideFinishedTxt={true}
            request={() => {
                dispatch(action_fetch_orders_notification())
            }}
            />

        <MeLoading loading={loading} />
    </div>
}


NotificationOrders.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_orders_notification(0, headers))
}

export default NotificationOrders
